import { Component, OnInit } from '@angular/core';
import { AboutpageService } from 'src/app/features/company/about/aboutpage.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { AboutHeroComponent } from './about-hero/about-hero.component';
import { CustomersComponent } from './customers/customers.component';
import { TeamOverviewComponent } from './team-overview/team-overview.component';
import { InvestorsComponent } from './investors/investors.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  imports: [
    AboutHeroComponent,
    InvestorsComponent,
    CustomersComponent,
    TeamOverviewComponent,
    CommonGetstartedComponent,
  ],
})
export class AboutComponent implements OnInit {
  getStartedData:any;
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  constructor(
    private aboutPageService: AboutpageService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }

  ngOnInit(): void {
    this.aboutPageService.getAboutPageData();
    let data = this.route.snapshot.data?.['seo']?.[0]?.fields;
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    this.metaBody.title = data?.seoMetadataReference?.fields.title || 'Verto: Cross-border payments platform for businesses';
    this.metaBody.description = data?.seoMetadataReference?.fields.description || 'Verto: Cross-border payments platform for businesses across the globe.';
    this.metaBody.type = 'About Us';
    this.metaBody.url = this.getUrl;
    this.metaBody.image = data?.heroContentPanel?.fields?.image[0]?.fields?.file?.url;
    this.meta.updateOG(this.metaBody);
    let getData = data?.getStartedContentPanel.fields;
    this.getStartedData = {
      header: getData.title,
      button1: {
        url: getData.buttons[0].fields.redirectLink,
        text: getData.buttons[0].fields.buttonText,
        target: getData.buttons[0].fields.actionType,
      },
      button2: {
        url: getData.buttons[1].fields.redirectLink,
        text: getData.buttons[1].fields.buttonText,
        target: getData.buttons[1].fields.actionType,
      },
    };
    this.posthogService.capturePageViewEvent('about_us');
  }
}
